import React from 'react';

// GLOBAL FUNCITONS
import { toNumber } from 'functions';

// LOCAL COMPONENTS
import TableBadge from './TableBadge';

// STYLES
import styles from './booleanCell.module.scss';

// MAIN COMPONENT
const BooleanCell = ({ children, value = children, placeholder }) => {
  return ![undefined, null, ''].includes(value) ? (
    <TableBadge className={styles.badge} badge={toNumber(value) === 1 ? 'success' : 'danger'}>
      {['No', 'Yes'][toNumber(value)]}
    </TableBadge>
  ) : (
    placeholder
  );
};

// EXPORT
export default BooleanCell;
